export const flexCenter = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

export const flexColumn = {
    display: 'flex',
    flexDirection: 'column',
};

export const flexRow = {
    display: 'flex',
    flexDirection: 'row',
};

export const flexSpaceBetween = {
    display: 'flex',
    justifyContent: 'space-between',
};

export const flexSpaceAround = {
    display: 'flex',
    justifyContent: 'space-around',
};

export const flexWrap = {
    display: 'flex',
    flexWrap: 'wrap',
};